import { applyIdsThemeCss } from './theme/theme-css-loader';
import './property-editors/ids-dropdown-editor';
import 'ids-enterprise-wc/components/ids-loading-indicator/ids-loading-indicator';

applyIdsThemeCss();
